"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionType = void 0;
exports.default = ConditionalElement;
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _useConditionalLogic = _interopRequireWildcard(require("../../../hooks/useConditionalLogic"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var ActionType = exports.ActionType = /*#__PURE__*/function (ActionType) {
  ActionType["SHOW"] = "show";
  ActionType["HIDE"] = "hide";
  return ActionType;
}({});
function ConditionalElement(props) {
  var rules = props.rules,
    children = props.children,
    _props$actionType = props.actionType,
    actionType = _props$actionType === void 0 ? ActionType.SHOW : _props$actionType,
    _props$logicType = props.logicType,
    logicType = _props$logicType === void 0 ? _useConditionalLogic.LogicType.ALL : _props$logicType,
    _props$elementsToMatc = props.elementsToMatch,
    elementsToMatch = _props$elementsToMatc === void 0 ? 1 : _props$elementsToMatc,
    _props$resetElements = props.resetElements,
    resetElements = _props$resetElements === void 0 ? true : _props$resetElements;
  var formMethods = (0, _reactHookForm.useFormContext)();
  var conditionIsValid = (0, _useConditionalLogic.default)(rules, {
    logicType: logicType,
    elementsToMatch: elementsToMatch
  });
  var getIsHidden = function getIsHidden(action, isValid) {
    return action === ActionType.SHOW && !isValid || action === ActionType.HIDE && isValid;
  };
  var isHidden = (0, _react.useMemo)(function () {
    return getIsHidden(actionType, conditionIsValid);
  }, [actionType, conditionIsValid]);
  var resetChild = function resetChild(child, shouldUnregister) {
    if (shouldUnregister) {
      formMethods.unregister(child.props.name);
    } else {
      formMethods.register(child.props.name);
      formMethods.resetField(child.props.name, {
        keepDirty: true,
        defaultValue: null
      });
    }
  };
  var resetChildren = function resetChildren(node, shouldUnregister) {
    var _node$props, _node$props$name, _node$props$actionTyp, _node$props2, _node$props3;
    if (node === null || ['string', 'undefined'].includes(_typeof(node))) return;
    if (Array.isArray(node)) {
      node.forEach(function (child) {
        return resetChildren(child, shouldUnregister);
      });
      return;
    }
    var isNestedConditionalElement = node.type.name === 'ConditionalElement' && ((_node$props = node.props) === null || _node$props === void 0 ? void 0 : _node$props.hasOwnProperty('rules'));
    var isFormElement = ((_node$props$name = node.props.name) === null || _node$props$name === void 0 ? void 0 : _node$props$name.length) > 0 && !isNestedConditionalElement;
    var nestedActionType = (_node$props$actionTyp = (_node$props2 = node.props) === null || _node$props2 === void 0 ? void 0 : _node$props2.actionType) !== null && _node$props$actionTyp !== void 0 ? _node$props$actionTyp : actionType;
    var nestedConditionIsValid = isNestedConditionalElement ? (0, _useConditionalLogic.default)((_node$props3 = node.props) === null || _node$props3 === void 0 ? void 0 : _node$props3.rules) : false;
    var shouldUnregisterChildren = shouldUnregister || getIsHidden(nestedActionType, nestedConditionIsValid);
    if (isFormElement) {
      resetChild(node, shouldUnregister);
    } else {
      resetChildren(node.props.children, shouldUnregisterChildren);
    }
  };
  (0, _react.useEffect)(function () {
    return function () {
      return resetChildren(children, true);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (resetElements) {
      resetChildren(children, isHidden);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [isHidden, resetElements]);
  if (isHidden) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}